import { Observable } from 'rxjs';
import { BoarwalkResources } from '../boardwalk-resources.model';

export abstract class CrossSellGateway {
  abstract getBoardwalkPage(boardwalk: string): Observable<BoarwalkResources>;
}
